module.exports = __webpack_public_path__ + "static/media/Loading.64f82305.scss";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Loading.scss
// module id = 61
// module chunks = 2